<script>
  import { Router, Route } from "svelte-navigator";
  import Navigation from "./components/shared/navigation/navigation.svelte";
  import HubspotAuthDialog from "./components/HubspotAuthDialog.svelte";
  import Dashboard from "./routes/dashboard.svelte";
  import SystemSettings from "./routes/systemSettings.svelte";
  import FieldSettings from "./routes/fieldSettings.svelte";
  import GrappleAuditLog from "./routes/auditLog.svelte";
  import Logs from "./routes/logs.svelte";
  import Opportunities from "./routes/opportunities.svelte";
  import Customer from "./routes/customer.svelte";
  import ProjectDetails from "./routes/projectDetails.svelte";
  import OpportunityTeams from "./routes/opportunityTeams.svelte";
  import Marketing from "./routes/marketing.svelte";
  import Statistics from "./components/statistics.svelte";
  import AIChatWidget from "./components/aiChatWidget.svelte";

  let sidebarWidth = 252;
  let topOffset = 0;

  const handleNavLayout = (e) => {
    sidebarWidth = e.detail.sidebarWidth;
    topOffset = e.detail.topOffset;
  };
</script>

<svelte:window on:nav-layout={handleNavLayout} />

<HubspotAuthDialog />

<Router primary={false}>
  <Navigation />
  <main
    class="min-h-screen bg-[#1b1e2f] transition-[margin] duration-200"
    style="margin-left:{sidebarWidth}px; margin-top:{topOffset}px"
  >
  <Route path="/" component={Dashboard} />
  <Route path="/opportunities" component={Opportunities} />
  <Route path="/customers" component={Customer} />
  <Route path="/projects" component={ProjectDetails} />
  <Route path="/teams" component={OpportunityTeams} />
  <Route path="/marketing" component={Marketing} />
  <Route path="/statistics" component={Statistics} />
  <Route path="/auditLog" component={GrappleAuditLog} />
  <Route path="/settings" component={SystemSettings} />
  <Route path="/field-settings" component={FieldSettings} />
  <Route path="/logs" component={Logs} />
  </main>
</Router>


<!-- Global AI Chat Widget — visible on every page -->
<AIChatWidget />
